import(/* webpackMode: "eager" */ "/mnt/volume-nbg1-1/apps/scriptus/frontend/src/app/error.tsx");
